var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload_wrapper custom-file"},[_c('div',{staticClass:"img_wrapper img-thumbnail rounded-circle"},[_c('div',{staticClass:"img",style:({
        backgroundImage: `url('${_vm.image}')`
      })})]),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"file_input",attrs:{"type":"file","lang":"zh-TW"},on:{"change":_vm.onChange}}),_vm._v(" "),_c('button-wrapper',{staticClass:"upload_button",attrs:{"fill":""}},[_vm._v("\n    上傳 LOGO\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }